import { render } from "./AddPageModal.vue?vue&type=template&id=0034c1a4&scoped=true"
import script from "./AddPageModal.vue?vue&type=script&lang=js"
export * from "./AddPageModal.vue?vue&type=script&lang=js"

import "./AddPageModal.vue?vue&type=style&index=0&id=0034c1a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0034c1a4"]])

export default __exports__